// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ss-root {
  position: relative;
  width: 100%;
  font-size: 14px;
}

.ss-control {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 9px 12px;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  color: #1e293b;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.ss-control:hover:not(:disabled) { border-color: #94a3b8; }
.ss-control.ss-open {
  border-color: #213a22;
  box-shadow: 0 0 0 3px rgba(33, 58, 34, 0.12);
}
.ss-disabled .ss-control { opacity: 0.6; cursor: not-allowed; }

.ss-value { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ss-placeholder { color: #94a3b8; }

.ss-icons { display: inline-flex; align-items: center; gap: 6px; flex-shrink: 0; }
.ss-clear {
  color: #94a3b8;
  font-size: 16px;
  line-height: 1;
  padding: 0 2px;
  border-radius: 4px;
}
.ss-clear:hover { color: #ef4444; background: #fef2f2; }
.ss-caret { color: #64748b; font-size: 11px; }
.ss-control.ss-open .ss-caret { transform: rotate(180deg); }

.ss-menu {
  position: absolute;
  z-index: 50;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.14);
  overflow: hidden;
}

.ss-search-wrap { padding: 8px; border-bottom: 1px solid #f1f5f9; }
.ss-search {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 13.5px;
  outline: none;
}
.ss-search:focus { border-color: #213a22; box-shadow: 0 0 0 2px rgba(33, 58, 34, 0.12); }

.ss-list { max-height: 240px; overflow-y: auto; padding: 4px; }
.ss-option {
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #334155;
}
.ss-option:hover { background: #f1f5f9; }
.ss-option.ss-selected {
  background: rgba(185, 146, 47, 0.14); /* brand gold tint */
  color: #213a22;
  font-weight: 600;
}
.ss-empty { padding: 14px 10px; color: #94a3b8; text-align: center; font-size: 13px; }

.ss-footer {
  padding: 6px 12px;
  border-top: 1px solid #f1f5f9;
  font-size: 11.5px;
  color: #94a3b8;
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchableSelect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gDAAgD;AAClD;AACA,mCAAmC,qBAAqB,EAAE;AAC1D;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;AACA,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;;AAE9D,YAAY,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC5E,kBAAkB,cAAc,EAAE;;AAElC,YAAY,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE;AACjF;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA,kBAAkB,cAAc,EAAE,mBAAmB,EAAE;AACvD,YAAY,cAAc,EAAE,eAAe,EAAE;AAC7C,gCAAgC,yBAAyB,EAAE;;AAE3D;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA,kBAAkB,YAAY,EAAE,gCAAgC,EAAE;AAClE;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;AACA,mBAAmB,qBAAqB,EAAE,4CAA4C,EAAE;;AAExF,WAAW,iBAAiB,EAAE,gBAAgB,EAAE,YAAY,EAAE;AAC9D;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA,mBAAmB,mBAAmB,EAAE;AACxC;EACE,oCAAoC,EAAE,oBAAoB;EAC1D,cAAc;EACd,gBAAgB;AAClB;AACA,YAAY,kBAAkB,EAAE,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAErF;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".ss-root {\n  position: relative;\n  width: 100%;\n  font-size: 14px;\n}\n\n.ss-control {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 9px 12px;\n  background: #fff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  cursor: pointer;\n  text-align: left;\n  color: #1e293b;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n.ss-control:hover:not(:disabled) { border-color: #94a3b8; }\n.ss-control.ss-open {\n  border-color: #213a22;\n  box-shadow: 0 0 0 3px rgba(33, 58, 34, 0.12);\n}\n.ss-disabled .ss-control { opacity: 0.6; cursor: not-allowed; }\n\n.ss-value { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.ss-placeholder { color: #94a3b8; }\n\n.ss-icons { display: inline-flex; align-items: center; gap: 6px; flex-shrink: 0; }\n.ss-clear {\n  color: #94a3b8;\n  font-size: 16px;\n  line-height: 1;\n  padding: 0 2px;\n  border-radius: 4px;\n}\n.ss-clear:hover { color: #ef4444; background: #fef2f2; }\n.ss-caret { color: #64748b; font-size: 11px; }\n.ss-control.ss-open .ss-caret { transform: rotate(180deg); }\n\n.ss-menu {\n  position: absolute;\n  z-index: 50;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.14);\n  overflow: hidden;\n}\n\n.ss-search-wrap { padding: 8px; border-bottom: 1px solid #f1f5f9; }\n.ss-search {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 8px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  font-size: 13.5px;\n  outline: none;\n}\n.ss-search:focus { border-color: #213a22; box-shadow: 0 0 0 2px rgba(33, 58, 34, 0.12); }\n\n.ss-list { max-height: 240px; overflow-y: auto; padding: 4px; }\n.ss-option {\n  padding: 8px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #334155;\n}\n.ss-option:hover { background: #f1f5f9; }\n.ss-option.ss-selected {\n  background: rgba(185, 146, 47, 0.14); /* brand gold tint */\n  color: #213a22;\n  font-weight: 600;\n}\n.ss-empty { padding: 14px 10px; color: #94a3b8; text-align: center; font-size: 13px; }\n\n.ss-footer {\n  padding: 6px 12px;\n  border-top: 1px solid #f1f5f9;\n  font-size: 11.5px;\n  color: #94a3b8;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
